import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '@/lib/hooks';
import { ROUTES } from '@/config/routes';

export const Route = createFileRoute('/')({
  component: IndexComponent,
});

function IndexComponent() {
  const { isAuthenticated, isAdmin } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  if (isAdmin) {
    return <Navigate to={ROUTES.ADMIN.ROOT} />;
  }

  return <Navigate to={ROUTES.DEPOSITS} />;
}
